// src/services/apaleo/config.ts
// Module-level configuration and the ALLOWED_PROPERTIES store. Extracted
// verbatim from src/services/apaleo.ts (Phase 5).
//
// ALLOWED_PROPERTIES is a mutable `let` and MUST keep its live-binding
// semantics: React consumers read it through useAllowedProperties()
// (useSyncExternalStore), non-React internals import the binding directly.
// ESM re-exports preserve liveness, so the shim can re-export it safely.

import type { MockDataShape } from './types';

export const MockData: MockDataShape = {
  MOCK_RESERVATIONS: [],
  MOCK_PROPERTY_PERFORMANCE: [],
  MOCK_COMPANIES: [],
  MOCK_RATE_PLANS: [],
  MOCK_UNITS: {},
  MOCK_UNIT_GROUPS: [],
  MOCK_OFFERS: [],
  MOCK_SERVICES: [],
  MOCK_MAINTENANCES: [],
  MOCK_GROUPS: [],
  MOCK_BLOCKS: [],
  MOCK_ROUTINGS: [],
};

export const IS_DEV = false;

export const DEFAULT_CONFIG = {
  apiUrl: "https://api.apaleo.com",
};

export const PAYMENT_API_URL = "https://payment.apaleo.com";

export const CITY_TAX_TOOL_PROPERTY_ID = "BERLIN";

export let ALLOWED_PROPERTIES: string[] = [];

export const allowedPropertiesListeners = new Set<() => void>();

export function subscribeAllowedProperties(listener: () => void): () => void {
  allowedPropertiesListeners.add(listener);
  return () => { allowedPropertiesListeners.delete(listener); };
}

export function getAllowedPropertiesSnapshot(): string[] {
  return ALLOWED_PROPERTIES;
}

export function setAllowedProperties(properties: string[]) {
  ALLOWED_PROPERTIES = properties;
  // Notify React consumers so they re-render with the populated list. Guarded
  // so a listener error can never break the caller (AppAuth's auth flow).
  allowedPropertiesListeners.forEach((listener) => {
    try { listener(); } catch (err) { console.error('ALLOWED_PROPERTIES listener failed:', err); }
  });
}

export interface FetchOptions {
  method?: string;
  headers?: Record<string, string>;
  body?: string;
  raw?: boolean;
}

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  return String(e ?? "");
}
